// extracted by mini-css-extract-plugin
export default {"loader":"iframe_loader__YK88K","loaderContent":"iframe_loaderContent__jzaf-","iFrame":"iframe_iFrame__hqqc9"};